import { errorSnackbar } from "@src/cloud-connect/snackbars/entities/snackbar-launcher";
import { getSupportTicketByIdWithLanguageUseCase } from "@src/cloud-connect/support/use-cases/get-support-ticket-by-id-with-language-use-case";
import { getLanguage } from "@src/cloud-connect/utils/get-language";
import { useI18N } from "@src/language/language-context";
import {
  updateModalsCloseDrawerModal,
  updateSupportTicketInformation,
} from "@src/reducers/your-reducer";
import { useState } from "react";
import { useDispatch } from "react-redux";

export const useClickOnCardGetTicketById = () => {
  const i18n = useI18N();
  const dispatch = useDispatch();
  const [isLoading, setIsLoading] = useState(false);

  const texts = {
    errorFetchingTicket: i18n("modules.ticketsTaskbarCard.errorFetchingTicket"),
  };

  const handleCardClick = async (ticketId: string) => {
    setIsLoading(true);
    const ticketInformationResponse = await getSupportTicketByIdWithLanguageUseCase(
      ticketId,
      getLanguage(),
    );

    if (!ticketInformationResponse.success || !ticketInformationResponse.data) {
      console.error(
        ticketInformationResponse.error || texts.errorFetchingTicket + ticketId,
      );
      errorSnackbar(
        ticketInformationResponse.error || texts.errorFetchingTicket + ticketId,
      );
    } else {
      dispatch(updateSupportTicketInformation(ticketInformationResponse.data));

      dispatch(
        updateModalsCloseDrawerModal({
          showModal: true,
          id: "supportChatDrawerModal",
        }),
      );
    }
    setIsLoading(false);
  };

  return { handleCardClick, isLoading };
};
